import LegalLayout, { Section } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      testid="privacy-page"
      path="/privacy"
      intro="This Privacy Policy explains what information Videoileo collects, how we use it, and the choices you have. We aim to collect only what we need to run the Service."
    >
      <Section title="1. Information we collect">
        <p><strong>Account information:</strong> your name, email address, and a securely hashed password. We never store your password in plain text.</p>
        <p><strong>Content you create:</strong> the topics and prompts you submit, and the scripts, voiceovers, images, and metadata generated for you.</p>
        <p><strong>Scheduling data:</strong> the platforms, dates, and captions you set for posts.</p>
        <p><strong>Usage &amp; preferences:</strong> credit balance, settings such as email-notification preferences, and your acceptance of our policies (including the date of acceptance).</p>
      </Section>

      <Section title="2. How we use your information">
        <p>We use your information to operate and provide the Service, including generating content you request, processing credits, scheduling posts, sending notification emails you have enabled, securing your account, and improving reliability. We do not sell your personal information.</p>
      </Section>

      <Section title="3. AI providers &amp; subprocessors">
        <p>To deliver core features, we share the minimum necessary data with trusted third-party processors:</p>
        <p><strong>Anthropic (Claude)</strong> — processes your topic/prompt to generate scripts.</p>
        <p><strong>ElevenLabs</strong> — converts your script text into voiceover audio.</p>
        <p><strong>OpenAI</strong> — generates scene visuals from your prompts.</p>
        <p><strong>Resend</strong> — delivers notification emails to your address (only when notifications are enabled).</p>
        <p>These providers process data under their own terms and privacy policies. We do not control their independent practices.</p>
      </Section>

      <Section title="4. Cookies &amp; local storage">
        <p>We use your browser's local storage to keep you signed in (an authentication token). We do not use third-party advertising or tracking cookies. Clearing your browser storage will sign you out.</p>
      </Section>

      <Section title="5. Email notifications">
        <p>If you enable email notifications, we send transactional emails (for example, when a video is scheduled or a post is published). You can turn these off at any time in Settings; turning them off stops future notification emails.</p>
      </Section>

      <Section title="6. Data retention">
        <p>We retain your account and content for as long as your account is active or as needed to provide the Service. You may request deletion of your account and associated content (see “Your rights”). Some records may be retained where required by law.</p>
      </Section>

      <Section title="7. Your rights &amp; choices">
        <p>You can access and update your name and password in Settings, toggle email notifications, and review your policy-acceptance status. Depending on your location, you may have rights to access, correct, export, or delete your personal data. To exercise these rights or request account deletion, contact support@videoileo.com.</p>
      </Section>

      <Section title="8. Security">
        <p>We use reasonable technical and organizational measures to protect your data, including password hashing and access controls. No method of transmission or storage is 100% secure, and we cannot guarantee absolute security.</p>
      </Section>

      <Section title="9. Children's privacy">
        <p>Videoileo is not directed to children under 16, and we do not knowingly collect personal information from them. If you believe a child has provided us data, contact us and we will delete it.</p>
      </Section>

      <Section title="10. International users">
        <p>Your information may be processed in countries other than where you live, including by the subprocessors listed above. By using the Service, you consent to such processing.</p>
      </Section>

      <Section title="11. Changes to this policy">
        <p>We may update this Privacy Policy from time to time. Material changes will be reflected by the “Last updated” date. Your continued use after changes constitutes acceptance.</p>
      </Section>
    </LegalLayout>
  );
}
